import { DOCUMENT_CONTROL_PANEL_HEIGHT } from 'constants/documents';
import { MODAL_BODY_DEFAULT_OFFSETS } from 'constants/ui';

const COLUMN_WIDTH = '12.5%';

export const getStyles = ({ shadows, palette }) => ({
  table: {
    padding: '16px',
    boxShadow: shadows[3],
    '& th': { width: COLUMN_WIDTH },
    border: `1px solid ${palette.primary['300']}`,
    borderRadius: '0 0 10px 10px',
  },
  root: {
    width: '100%',
    overflow: 'hidden',

    '& .document_view__document_pages_wrapper': {
      maxHeight: `calc(100vh - ${DOCUMENT_CONTROL_PANEL_HEIGHT + MODAL_BODY_DEFAULT_OFFSETS}px)`,
    },
  },
  header: {
    padding: '12px 16px',
    backgroundColor: palette.primary['300'],
    borderRadius: '10px 10px 0 0',
  },
});
